export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4733.7859380c.jpg";